import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import { Panel } from "@poseidon/ui/components/Panel";
import TableHead from "@mui/material/TableHead";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputCell } from "./InputCell";
import { usePermissions } from "@poseidon/ui/components";
import LinearProgress from "@mui/material/LinearProgress";
import { useTermLimitsState } from "./useTermLimitsState";
import AddIcon from "@mui/icons-material/Add";
import Alert from "@mui/material/Alert";

const LimitRow = ({
  row,
  onDelete,
  onChange,
  onBlur,
  isLast,
  validationErrors,
}) => {
  const rowErrors = validationErrors?.find((v) => v.id === row.id);

  return (
    <TableRow>
      <TableCell>
        <IconButton aria-label="delete">
          <DeleteIcon onClick={onDelete} />
        </IconButton>
      </TableCell>
      <InputCell
        type="amount"
        row={row}
        field="fromAmount"
        disabled={true}
        onChange={onChange}
        onBlur={onBlur}
        error={rowErrors?.fieldErrors?.fromAmount}
      />
      <InputCell
        type="amount"
        row={row}
        field="toAmount"
        onChange={onChange}
        onBlur={onBlur}
        allowInfinity={isLast}
        error={rowErrors?.fieldErrors?.toAmount}
      />
      <InputCell
        type="term"
        row={row}
        field="minMonths"
        onChange={onChange}
        onBlur={onBlur}
        error={rowErrors?.fieldErrors?.minMonths}
      />
      <InputCell
        type="term"
        row={row}
        field="maxMonths"
        onChange={onChange}
        onBlur={onBlur}
        allowInfinity={true}
        error={rowErrors?.fieldErrors?.maxMonths}
      />
    </TableRow>
  );
};
export default function TermLimits() {
  const { canWrite } = usePermissions();
  const {
    rows,
    actions,
    loading,
    loadError,
    saving,
    handleSave,
    validationErrors,
  } = useTermLimitsState();
  if (loading) {
    return <LinearProgress />;
  }
  if (loadError) {
    return <Alert severity="error">Error loading rate matrix</Alert>;
  }
  return (
    <Panel
      title="Term Limits"
      actions={
        <Button
          size="small"
          onClick={handleSave}
          disabled={saving || !canWrite}
        >
          Save
        </Button>
      }
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <IconButton onClick={() => actions.add()} aria-label="add">
                <AddIcon />
              </IconButton>
            </TableCell>
            <TableCell>From amount</TableCell>
            <TableCell>To amount</TableCell>
            <TableCell>Min term</TableCell>
            <TableCell>Max term</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx, all) => (
            <LimitRow
              isLast={idx === all.length - 1}
              key={row.id}
              row={row}
              onDelete={() => actions.delete(row.id)}
              onBlur={() => actions.sort()}
              onChange={(updates) => actions.update(row.id, updates)}
              validationErrors={validationErrors}
            />
          ))}
        </TableBody>
      </Table>
      {saving && <LinearProgress />}
    </Panel>
  );
}
